import { RegexPhoneNumber } from "configs/regex";
import * as Yup from "yup";

export const initialFilter = {
    filter: {
        paramsCustomerName: "",
    },
    pageNumber: 1,
    pageSize: 500,
};

export const validationSchema = Yup.object().shape({
    customer_name: Yup.string().required("Nama Pelanggan wajib diisi!"),
    phone_number: Yup.string()
        .matches(RegexPhoneNumber, "Format No.Telepon tidak sesuai")
        .required("No.Telepon wajib diisi!"),
    total_occupants: Yup.number().required("Jumlah Penghuni wajib diisi!"),
    building_type: Yup.string()
        .nullable()
        .required("Tipe Bangunan wajib diisi!"),
    district: Yup.object().nullable().required("Kecamatan wajib diisi!"),
    village: Yup.object().nullable().required("Desa wajib diisi!"),
    address: Yup.string().required("Alamat wajib diisi!"),
});
